import { compareAsc, parse } from "date-fns";
import * as types from "../constants/ActionTypes";
import Moment from "moment";

const messagemail = (state = [], action) => {
  // console.log("2342#%:235", action)
  switch (action.type) {
    case types.ADD_MESSAGE_MAIL:
      return [
        ...state,
        {
          id: action.id,
          cdr: action.cdr,
          operator: action.operator,
          date_sending: action.date_sending,
          body_msg: `${action.body_msg}`,
          attachments: action.attachments,
          recipients: action.recipients,
          externalcode: action.externalcode,
          favorite: action.favorite,
          caption: action.caption,
          msg_id: action.msg_id,
          isAgent: action.isAgent,
        },
      ].sort((a, b) => {
        try {
          const dataA = parse(a.date_sending, "dd/MM/yyyy HH:mm", new Date());
          const dataB = parse(b.date_sending, "dd/MM/yyyy HH:mm", new Date());

          const order = compareAsc(dataA, dataB);
          if (order === 0 && Boolean(a.id) && Boolean(b.id)) {
            return parseInt(a.id) - parseInt(b.id);
          }
          return order;
        } catch {
          return 0;
        }
      });
    case types.DEL_MESSAGE_MAIL:
      return state.filter((atd) => parseInt(atd.cdr) !== parseInt(action.cdr));
    case "CHANGE_CODE_MAIL":
      if (state) {
        return state.map((mails) => {
          if (parseInt(action.externalcode) === parseInt(mails.externalcode)) {
            return { ...mails, id: action.serviceattmediaid };
          }
          return mails;
        });
      }
    case "CHANGE_FAVORITE_MAIL":
      if (state) {
        return state.map((mails) => {
          if (parseInt(action.externalcode) === parseInt(mails.externalcode)) {
            return { ...mails, favorite: action.favorite };
          }
          return mails;
        });
      }
    case types.ADD_ATTACHMENTS_MAIL:
      if (state) {
        return state.map((mails) => {
          if (parseInt(action.id) === parseInt(mails.id)) {
            return { ...mails, attachments: action.attachments };
          }
          return mails;
        });
      }
    default:
      return state;
  }
};

export default messagemail;
